import { useEffect, useRef, useState } from "react";

const PIXELS_PER_SECOND = 35;

const AD_IMAGES = [
  "/images/publicidad/photo_4931970053796728564_y.jpg",
  "/images/publicidad/photo_4931970053796728565_y.jpg",
  "/images/publicidad/photo_4931970053796728566_x.jpg",
  "/images/publicidad/photo_4931970053796728567_x.jpg",
  "/images/publicidad/photo_4931970053796728568_y.jpg",
  "/images/publicidad/photo_4931970053796728569_m.jpg",
  "/images/publicidad/photo_4931970053796728579_y.jpg",
];

const AdItem = ({ src }) => (
  <img
    src={src}
    alt=""
    className="h-8 w-auto rounded-md shrink-0 object-cover"
    style={{ border: "1px solid rgba(255,255,255,.15)" }}
  />
);

export const HeaderAdTicker = ({ images = AD_IMAGES }) => {
  const trackRef = useRef(null);
  const [trackWidth, setTrackWidth] = useState(0);

  useEffect(() => {
    if (!trackRef.current || images.length === 0) return;

    const observer = new ResizeObserver(([entry]) => {
      const width = entry.target.getBoundingClientRect().width;
      setTrackWidth((prev) => (Math.abs(prev - width) > 0.5 ? width : prev));
    });
    observer.observe(trackRef.current);

    return () => observer.disconnect();
  }, [images]);

  if (images.length === 0) return null;

  const duration = trackWidth > 0 ? trackWidth / PIXELS_PER_SECOND : 0;

  return (
    <div className="w-full overflow-hidden">
      <style>{`
        @keyframes header-ad-ticker-scroll {
          from { transform: translateX(-${trackWidth}px); }
          to { transform: translateX(0); }
        }
      `}</style>
      <div
        className="flex items-center whitespace-nowrap"
        style={{
          width: "max-content",
          animation: trackWidth > 0 ? `header-ad-ticker-scroll ${duration}s linear infinite` : "none",
        }}
      >
        <div ref={trackRef} className="flex items-center gap-3 pr-3 shrink-0">
          {images.map((src) => (
            <AdItem key={src} src={src} />
          ))}
        </div>
        <div className="flex items-center gap-3 pr-3 shrink-0" aria-hidden="true">
          {images.map((src) => (
            <AdItem key={`dup-${src}`} src={src} />
          ))}
        </div>
      </div>
    </div>
  );
};
